import BaseLayout from './base-layout';

export default BaseLayout;
